import { gql } from "@apollo/client";
export const WINE_CREATE = gql `
  mutation WineCreate($input: WineCreateInput!) {
    WineCreate(input: $input)
  }
`;
